import { Tooltip } from "~/components/reusable/Tooltip"
import { formatValue, formatValueList } from "./erpTooltip"

type ErpIndicatorProps = {
  erpValue?: string | number | Date | null
  erpValues?: (string | number | Date)[]
  unit?: string
}

export const ErpIndicator = ({ erpValue, erpValues, unit }: ErpIndicatorProps) => {
  const hasErpData = erpValue != null || (erpValues && erpValues.length > 0)
  if (!hasErpData) return null

  const unitStr = unit ? ` ${unit}` : ""
  const tooltipText =
    erpValues && erpValues.length > 1
      ? `ERP values: ${formatValueList(erpValues)}${unitStr}`
      : erpValue != null
        ? `ERP value: ${formatValue(erpValue)}${unitStr}`
        : "No ERP value"

  const displayText =
    erpValues && erpValues.length > 1 ? "Mixed" : erpValue != null ? formatValue(erpValue) : "-"

  return (
    <Tooltip title={tooltipText}>
      <div className="flex items-center justify-center" aria-label="ERP managed field">
        <span className="text-xs text-fg-subtle truncate" title={displayText}>
          {displayText}
        </span>
      </div>
    </Tooltip>
  )
}
